import IntroBanner from "../../components/intro-banner/intro-banner/intro-banner.component";
import "./about-us-page.styles.css";

import AboutUsImage from "../../../src/assets/images/about-young-01.png";
import ResponsiveAboutUsImage from "../../../src/assets/images/about-young-01.png";
import AboutUsInfoRow from "../../components/about-us-info-row/about-us-info-row.component";

import AboutSectionImg1 from "../../../src/assets/images/about-young-02.png";
import AboutSectionImg2 from "../../../src/assets/images/about-young-03.png";

const AboutUsPage = () => {
  const AboutUsBannerData = [
    {
      img: AboutUsImage,
      ResponsiveImg: ResponsiveAboutUsImage,
      title: "در باره یانگ",
    },
  ];

  const AboutUsInfoData = [
    {
      id: 1,
      title: "ما اینجا نیومدیم که فقط لباس بسازیم",
      text: " اومدیم برای استایل های خیابونی که پیشرفته و کاربردی‌ان. YOUNG برای کساییِ که از هر چیزی که معمولی باشه فراری‌ان و همیشه دنبال یه چیزی فراتر از انتظار می‌گردن. طراحی‌های ما با دقت و خلاقیت بالا ساخته می‌شن، طوری که نه تنها تو خیابون یا تو هر موقعیت دیگه‌ای که بخوای، بدرخشی، بلکه با کاربردی بودنش به درد هر لحظه و هر شرایطی می‌خوره",
      img: AboutSectionImg1,
    },
    {
      id: 2,
      title: "بعضی لباسا چند حالت دارن",
      text: "بعضی‌ها رو می‌تونی با هم ترکیب کنی، ولی همشون یه چیزو ثابت می‌کنن: انتخاب با خودته. ما نمی‌خواهیم فقط لباس بفروشیم، می‌خواهیم یه طرز فکر بسازیم—یه راهی که تو هر موقعیت بتونی بهترین نسخه از خودت باشی.",
      img: AboutSectionImg2,
    },
  ];

  return (
    <div className="about-us-page">
      <IntroBanner cat={AboutUsBannerData[0]} TitleclassName="about-us-title" />
      <div className="container">
        {AboutUsInfoData.map((item) => (
          <AboutUsInfoRow key={item.id} cat={item} />
        ))}
      </div>
    </div>
  );
};

export default AboutUsPage;
